import { socialApiClient } from '@/shared/api-client/social-api-client';
import { paginationRequestSchema, type PaginationResponse } from '@/shared/schema/pagination';
import z from 'zod';
import { CampaignListSort, CampaignStatus, type CampaignBase, type CampaignKeywordSet } from '../';

// 캠페인 리스트 조회

export const fetchCampaignsRequestSchema = z.object({
  name: z.string().optional(),
  status: z.enum(CampaignStatus).optional(),
  sort: z.enum(CampaignListSort),
  ...paginationRequestSchema.shape,
});

export type CampaignListRequest = z.infer<typeof fetchCampaignsRequestSchema>;
export type CampaignListItemData = CampaignBase &
  CampaignKeywordSet & {
    creator_count: number;
    profile_image_urls: Array<string>;
  };

export type CampaignListResponse = {
  pagination: PaginationResponse;
  items: Array<CampaignListItemData>;
};

export async function FetchCampaigns(
  workspaceId: string,
  request: CampaignListRequest,
  signal?: AbortSignal,
): Promise<CampaignListResponse> {
  const parsedRequest = fetchCampaignsRequestSchema.parse(request ?? {});
  const response = await socialApiClient.get(`workspaces/${workspaceId}/campaigns`, {
    searchParams: parsedRequest,
    signal,
  });
  return await response.json();
}
